<template>
  <div id="evCharging" class="evCharging" v-loading.fullscreen.lock="pageLoading">
    <div class="main">
      <!-- Title -->
      <TitleBar
        :title="$t('EvCharging.Title')"
        :introduction="{
          link: 'https://www.smartdaily.com.tw/community-evcharger-management/',
          product_id: 'ev_charging',
          product_name: $t('EvCharging.Title'),
          subpage_name: tabName
        }"
        :tip="$t('EvCharging.Tip')"
      />
      <!-- TAB -->
      <el-tabs v-model="activeTabName" class="evCharging-tabs" :before-leave="tabBeforeLeave">
        <el-tab-pane :label="$t('EvCharging.ChargingDashboard')" name="chargingDashboard" lazy>
          <Dashboard :active-tab-name="activeTabName" :charging-feature="chargingFeature" />
        </el-tab-pane>
        <el-tab-pane :label="$t('EvCharging.ConnectorsManagement')" name="connectorsManagement" lazy>
          <ConnectorsManagement />
        </el-tab-pane>
        <el-tab-pane :label="$t('EvCharging.ChargingRecord')" name="chargingRecord" lazy>
          <ChargingRecord />
        </el-tab-pane>
        <el-tab-pane :label="$t('EvCharging.RateSetting')" name="rateSetting" lazy>
          <RateSetting />
        </el-tab-pane>
        <!-- 這次版本先不開放此功能 -->
        <!-- <el-tab-pane label="充電樁歷史數據統計" name="connectorHistoryList" lazy>
          <ConnectorHistoryList />
        </el-tab-pane> -->
        <el-tab-pane v-if="showMonthlyStatementTab" :label="$t('EvCharging.ChargingFeeList')" name="chargingFeeList" lazy>
          <ChargingFeeList :charging-feature="chargingFeature" />
        </el-tab-pane>
        <el-tab-pane v-if="showManagementFeeStatementTab" :label="$t('EvCharging.ManagementFeeList.Title')" name="managementFeeList" lazy>
          <ManagementFeeList :charging-feature="chargingFeature" />
        </el-tab-pane>
      </el-tabs>
    </div>
    <PrivateChargingAuthorizedDialog />
  </div>
</template>
<script>
import { apiEvCharging } from '@/api/EvCharging'
import TitleBar from '@/components/PageTitleBar.vue'
import Dashboard from '@/views/EvCharging/tabs/Dashboard.vue'
import ChargingRecord from '@/views/EvCharging/tabs/ChargingRecord.vue'
import ConnectorsManagement from '@/views/EvCharging/tabs/ConnectorsManagement.vue'
import RateSetting from '@/views/EvCharging/tabs/RateSetting.vue'
import ChargingFeeList from '@/views/EvCharging/tabs/ChargingFeeList.vue'
import ManagementFeeList from '@/views/EvCharging/tabs/ManagementFeeList.vue'
import PrivateChargingAuthorizedDialog from '@/views/EvCharging/components/PrivateChargingAuthorizedDialog.vue'


export default {
  components: {
    TitleBar,
    Dashboard,
    ChargingRecord,
    ConnectorsManagement,
    RateSetting,
    ChargingFeeList,
    ManagementFeeList,
    PrivateChargingAuthorizedDialog
  },
  data () {
    return {
      pageLoading: true,
      activeTabName: this.$route.name,
      showMonthlyStatementTab: false,
      showManagementFeeStatementTab: false,
      chargingFeature: {}
    }
  },
  computed: {
    tabName () {
      switch (this.activeTabName) {
      case 'chargingDashboard':
        return this.$t('EvCharging.ChargingDashboard')
      case 'connectorsManagement':
        return this.$t('EvCharging.ConnectorsManagement')
      case 'chargingRecord':
        return this.$t('EvCharging.ChargingRecord')
      case 'rateSetting':
        return this.$t('EvCharging.RateSetting')
      case 'chargingFeeList':
        return this.$t('EvCharging.ChargingFeeList')
      case 'managementFeeList':
        return this.$t('EvCharging.ManagementFeeList.Title')
      default:
        return ''
      }
    }
  },
  mounted () {
    this.getFeatures()
  },
  methods: {
    tabBeforeLeave (activeName) {
      // 切換 TAB 時需更改路由
      this.$router.push({
        name: activeName
      })
      return true
    },
    async getFeatures () {
      // 拿取社區的充電樁功能細項：該社區 是否有私有充電樁(管理費)、是否有公共充電樁(線上付款)、是否有供電盤
      try {
        const res = await apiEvCharging.Management.getFeatures()
        if (res?.data.Data.ShowMonthlyStatementTab) this.showMonthlyStatementTab = true
        if (res?.data.Data.ShowManagementFeeStatementTab) this.showManagementFeeStatementTab = true
        this.chargingFeature = res?.data.Data || {}
      } catch (err) {
        console.log(err)
      } finally {
        this.pageLoading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.evCharging {
  @include mainLayer();
  ::v-deep .emergency {
    color: $dangerColor;
  }
  ::v-deep pre {
    white-space: pre-wrap; /* Since CSS 2.1 */
    white-space: -moz-pre-wrap; /* Mozilla, since 1999 */
    white-space: -pre-wrap; /* Opera 4-6 */
    white-space: -o-pre-wrap; /* Opera 7 */
    word-wrap: break-word; /* Internet Explorer 5.5+ */
  }
  .evCharging-tabs {
    ::v-deep .el-tabs {
      @include basicTabs;
      &__header {
        margin: 0 0 0;
      }
      &__item {
        min-width: 130px;
        height: 42px;
        span {
          width: 100%;
          display: inline-block;
        }
      }
    }
  }
}
</style>
